// Вспомогательные функции для ProductForm

const resolveAccessoryIdValue = (value) => {
    if (!value) return '';

    if (typeof value === 'object') {
        return String(value._id || value.groupId || value.id || value.value || '').trim();
    }

    return String(value).trim();
};

// Допродажа привязана к КАРТОЧКЕ товара (groupId). Читаем из поля формы
// accessoryGroupId, либо из сырого accessories[0].groupId, либо из резолвнутого
// productGroup._id (на случай легаси-записей с offerId).
export const normalizeAccessoryGroupId = (offer = {}) => {
    if (offer?.accessoryGroupId !== undefined) {
        return resolveAccessoryIdValue(offer.accessoryGroupId);
    }
    const firstAccessory = Array.isArray(offer?.accessories) ? offer.accessories[0] : null;
    return (
        resolveAccessoryIdValue(firstAccessory?.groupId) ||
        resolveAccessoryIdValue(firstAccessory?.productGroup)
    );
};

export const buildOfferAccessoriesPayload = (offer = {}) => {
    const accessoryGroupId = normalizeAccessoryGroupId(offer);
    if (!accessoryGroupId) {
        return { accessories: [] };
    }

    return {
        accessories: [
            {
                groupId: accessoryGroupId,
                selectedByDefault: false,
            },
        ],
    };
};

export const areOfferAccessoriesEqual = (leftOffer = {}, rightOffer = {}) => (
    normalizeAccessoryGroupId(leftOffer) === normalizeAccessoryGroupId(rightOffer)
);

export const buildOfferOptionKey = (offer = {}) => JSON.stringify(
    Object.entries(offer?.optionMap || offer?.options || {})
        .filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== '')
        .sort(([left], [right]) => left.localeCompare(right))
);
